import bus from '~/bus'
import {getEventFile} from '~/helpers/eventHelper'

export default {
  name: 'trashed',
  do: function (payload) {
    console.log('DEBUG trashed: ', this, payload)
    bus.$emit('refreshTrash')
    if (this.file === 'trash' || this.file === 'shared') {
      bus.$emit('doBackgroundReload', 'trashed')
    }
    if (this.file === 'recent' && payload.recent) {
      bus.$emit('deleteFile', payload.deprecated_file_id)
    }
    if (this.fileChildren && this.fileChildren.includes(payload.parent_id)) {
      getEventFile(payload.deprecated_parent_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
    if (this.file === payload.owner) {
      if (this.fileChildren && this.fileChildren.length === 1 && this.fileChildren.includes(payload.file_id)) {
        bus.$emit('showWarningAndRedirect', 'NoFilesSharedWarning')
      } else {
        bus.$emit('deleteFile', payload.deprecated_file_id)
      }
    }
    if (this.fileChildren && this.fileChildren.includes(payload.file_id)) {
      bus.$emit('deleteFile', payload.deprecated_file_id)
    }
    if (this.file === payload.file_id) {
      bus.$emit('showWarningAndRedirect')
    }

    if (this.fileAncestors && this.fileAncestors.includes(payload.file_id)) {
      getEventFile(this.file).then((response) => {
        bus.$emit('refreshAppbar', response)
      }).catch(() => {
        bus.$emit('showWarningAndRedirect')
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/trashed.js